
export const  ADD_FOLDER = 'ADD_FOLDER';
export const  RENAME_FOLDER = 'RENAME_FOLDER';
export const  UPLOAD_FILES = 'UPLOAD_FILES';
export const  DELETE_FOLDER = 'DELETE_FOLDER';
export const  CUT_FOLDER = 'CUT_FOLDER';
export const  PASTE_FOLDER = 'PASTE_FOLDER';